<template lang="pug">
  .wrap
    page-title Your Users

    list-header(:on-search='search')
      template(slot='action')
        a(:href="reportCsvUrl")
          el-button Download User Report

    el-table(:data="list.results" empty-text="No entries" v-loading='loading')
      el-table-column(label="Name" prop='name' class-name='title-cell' min-width="300")
        template(slot-scope="scope")
          p {{ scope.row.user.firstName }} {{ scope.row.user.lastName }}
          small {{ scope.row.user.email }}

      el-table-column(label="Programs completed" prop='type' align='center' width="200")
        template(slot-scope="scope")
          | {{ scope.row.completedProgramsCount }} / {{ scope.row.assignedProgramsCount }}

      el-table-column(label="Courses completed" width='200' align='center')
        template(slot-scope="scope")
          template(slot-scope="scope")
          | {{ scope.row.completedCoursesCount }} / {{ scope.row.assignedCoursesCount }}

      el-table-column(width='300' align='right')
        template(slot-scope="scope")
          router-link(:to="{ name: 'itrain:usersReportDetail', params: { id: scope.row.id } }")
            el-button(size='small') View

    .pages
      el-pagination(layout="prev, pager, next" @current-change='changePage' :total="list.count" :page-size='pageSize')


</template>

<script>
import PageTitle from "@/shared/components/layout/PageTitle";
import ListHeader from "@/shared/components/ListHeader";

export default {
  components: { PageTitle, ListHeader },
  data() {
    return {
      loading: true,
      pageSize: 40,
      searchParams: null,
      list: {
        retults: [],
        count: 0
      }
    };
  },
  computed: {
    reportCsvUrl() {
      const params = {
        ...this.searchParams,
        company: this.$store.getters["auth/activeCompany"].id,
        format: "csv"
      };
      return this.$store.getters["api/generateUrl"]({
        path: "/itrain/reports/users/",
        params
      });
    }
  },
  methods: {
    async loadList({ params = {} } = {}) {
      const mergedParams = {
        ...params,
        pageSize: this.pageSize,
        company: this.$store.getters["auth/activeCompany"].id
      };

      this.loading = true;
      this.list = await this.$store.dispatch("api/sendRequest", {
        method: "get",
        url: "/itrain/reports/users/",
        params: mergedParams
      });

      this.loading = false;
    },
    changePage(page) {
      this.loadList({ params: { page } });
    },
    search(q) {
      if (q) {
        this.searchParams = { q };
      } else {
        this.searchParams = null;
      }
      this.loadList({ params: { q } });
    }
  },
  created() {
    this.loadList();
  }
};
</script>

<style scoped lang="scss">
.emptystate {
  width: 100%;
}

.message {
  font-size: 13px;
  color: #666;
  line-height: 20px;
}

.wrap {
  :global(td.stat-cell .cell) {
    font-size: 16px;
    line-height: 20px;
    padding: 20px 0;
  }

  :global(.el-table td) {
    height: 60px;
  }

  :global(td .cell) {
    line-height: 24px;
  }

  :global(.status-cell .cell) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :global(td.title-cell) {
    font-size: 16px;
    cursor: pointer;
  }
}

.schedule {
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: column;
}

.schedule-time {
  font-size: 16px;
}

.schedule-day {
  color: #666;
}

.report-icon {
  margin-right: 8px;
}

.pages {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999;
  border: 1px solid #ddd;
  border-radius: 2px;
  background: white;
  padding: 80px 0;
  flex-direction: column;
}

.placeholder-actions {
  margin-top: 30px;
}

.emptystate {
  width: 100%;
}

.assigned-group {
  margin-right: 5px;
  margin-bottom: 4px;
  &:last-child {
    margin-right: 0;
  }
}
</style>
